import { ref } from "vue";

const DWL_REGEX = /\/(?<language>[A-Za-z]{2})-(?<country>[A-Za-z]{2})\//

interface Localization {
    Language: string;
    Country: string;
    Locale: string;
} 

const getLocalization = () => {
    const checkUrl = window.location.pathname.match(DWL_REGEX)

    if (!checkUrl) {
        const localization = ref<Localization>({
            Language: 'en',
            Country: 'GB',
            Locale: 'en_GB'
        })

        return localization
    }

    const localization = ref<Localization>({
        Language: checkUrl.groups?.language ?? 'en',
        Country: (checkUrl.groups?.country)?.toUpperCase() ?? 'GB',
        Locale: `${checkUrl.groups?.language ?? 'en'}_${(checkUrl.groups?.country)?.toUpperCase() ?? 'GB'}`
    })

    return localization
}

export type { Localization }
export { getLocalization }